import {Component, Prop} from 'vue-property-decorator'
import {EquipmentViewmodal} from './equipment.viewmodal'
import {namespace} from 'vuex-class'
import {SEARCH_AUTOCOMPLETE, SEARCH_MODULE_NAMESPACE, SEARCH_REQUEST_BYKEYS_FORCE} from '../../../../store/search'
import {SearchEntities, CrudStatus} from '../../../../common/enums'
import {MAINTENANCE_MODULE_NAMESPACE} from '../../../../store/maintenance'
import {BLOCK_GET_BLOCK, BLOCK_GET_BLOCKS, BLOCK_MODULE_NAMESPACE} from '../../../../store/block'
import {BlockDto, IBlockListingViewModel, IBlockParameter} from '../../../../models/block'
import {IApartmentListingViewModel} from '../../../../models/apartment'
import {APARTMENT_GET_APPARTMENTS_AUTOCOMPLETE, APARTMENT_MODULE_NAMESPACE} from '../../../../store/apartment'
import {TICKET_MODULE_NAMESPACE} from '../../../../store/ticket'
import { SERIVCEBOOK_MODULE_NAMESPACE, SERVICEBOOK_GET_SERVICEBOOK } from '../../../../store/service-book'
import { IServiceBookDetails } from '../../../../store/service-book/service-book-state.store'

const SearchStore = namespace(SEARCH_MODULE_NAMESPACE)
const EquipmentStore = namespace(MAINTENANCE_MODULE_NAMESPACE)
const BlockStore = namespace(BLOCK_MODULE_NAMESPACE)
const ApartmentStore = namespace(APARTMENT_MODULE_NAMESPACE)
const TicketStore = namespace(TICKET_MODULE_NAMESPACE)
const ServiceBookStore = namespace(SERIVCEBOOK_MODULE_NAMESPACE)

@Component({})
class BlockEquipmentModalVertical extends EquipmentViewmodal {

  @Prop({ type: [Boolean] })
  isVehicle: boolean;

  /* eslint-disable no-undef */

  @ServiceBookStore.Action(SERVICEBOOK_GET_SERVICEBOOK)
  storeGetServiceBook: (id:string) => Promise<any>

  @ServiceBookStore.Getter currentServiceBook:IServiceBookDetails


  @BlockStore.Action(BLOCK_GET_BLOCK)
  storeGetBlockById: (blockId: string) => Promise<any>;
  @SearchStore.Getter caretakers: any[];
  @SearchStore.Getter managers: any[];
  @EquipmentStore.Getter equipmentCrudActionStatus: CrudStatus;
  @BlockStore.Getter currentBlock: IBlockListingViewModel;
  @BlockStore.Getter blocks: BlockDto[];
  @TicketStore.Getter characterProblems: any;
  @SearchStore.Getter independent_contractors: any[];

  @ApartmentStore.Action(APARTMENT_GET_APPARTMENTS_AUTOCOMPLETE)
  storeGetApartmentsAutocomplete: (payload: { blockId?: number, entity?: number[], key?: string, limit?: number }) => Promise<any>;
  @SearchStore.Action(SEARCH_REQUEST_BYKEYS_FORCE)
  storeGetIndependentContractors: (payload: { keys: string[], force?: boolean }) => Promise<any[]>;
  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetResources: (payload: { entity: SearchEntities[], query?: string }) => Promise<any[]>;
  @BlockStore.Action(BLOCK_GET_BLOCKS)
  storeGetBlocks: (payload: { param: IBlockParameter, merge?: boolean }) => Promise<any>;

  dtApartments: IApartmentListingViewModel[];
  dtSavedBlocks: any[]

  dtRules: {
    namesRules?: any;
    characterProblemsRules_1?: any;
    characterProblemsRules_2?: any;
    nbEquipmentRules?: any;
  }

  constructor() {
    super()
    this.dtRules = {}
    this.dtApartments = []
    this.dtSavedBlocks = []
  }



  get isServiceBook():boolean {
    return this.$route.path.includes('service-book')
  }


  beforeMount()
  {
    if(this.isServiceBook)
    {
      const blockId = this.currentServiceBook.apartment.fk_apartment_block
      this.storeGetBlockById(blockId).then(r=>{
        this.Block = this.currentBlock.id
      })
    }
  }


  mounted() {

    // === service book
    if(this.isServiceBook)
    {
      this.Block = this.currentServiceBook.apartment.fk_apartment_block
      this.Apartment = this.currentServiceBook.apartment.id
    }


    this.dtRules = {
      namesRules: [
        v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.equipmentHeaders.name)})
      ],
      characterProblemsRules_1: [(v) => !!v || `${this.$t(this.lblSetting.characterProblemRequired)}`],
      characterProblemsRules_2: [(v) => !!v || `${this.$t(this.lblSetting.characterProblemRequired)} 2`],
      nbEquipmentRules: [(v) => v > 0 || this.$t(this.lblSetting.numberPositive)]
    }
    if (this.isUpdateAction) {
      if (this.dtSavedBlocks.findIndex(x => x.id === this.equipment.block.id) === -1) {
        this.dtSavedBlocks.push(this.equipment.block)
      }
    } else {
      this.Block = this.currentBlock.id
    }
    this.storeGetApartmentsAutocomplete({blockId: this.Block})
      .then(res => {
        this.dtApartments = res
      })
    this.storeGetIndependentContractors({keys: [SearchEntities.IndependentContractor], force: true})
      .catch(error => console.log(error))

    if(this.isVehicle)
    {
      this.Lvl1 = 238
    }
  }

  get lblSetting() {
    return {
      ...require('@/locales/ticket').default,
      ...require('@/locales/equipment').default,
      ...require('@/locales/validation-messages').default
    }
  }

  get textConfigs() {
    return require('@/assets/json-resources/text-field-configs.json')
  }

  get isUpdateAction(): boolean {
    return this.equipmentCrudActionStatus === CrudStatus.Update
  }

  get coBlocks() {
    return this.dtSavedBlocks.concat([this.currentBlock]).map(x => ({
      text: x.name,
      firstname: x.name,
      value: x.id
    }))
  }

  get coApartments() {
    return (this.dtApartments || []).map(x => ({
      value: x.id,
      text: x['location_number'] ? x['location_number'] + ' / ' + x['apartment_number'] : x['apartment_number'],
      ...x
    }))
  }

  get characterProblems2() {
    if (!this.Lvl1) return []
    return this.characterProblems.level_1.find(x => x.id === this.Lvl1).level_2
  }

  get coContractors() {
    return (this.independent_contractors || []).map(x => {
      return {lastname: x.lastname, firstname: x.firstname, id: x.id, text: `${x.firstname} ${x.lastname}`}
    })
  }

  handleChangeCharPb1(value) {
    this.Lvl2 = null
  }

  handleChangeCharPb2(value) {
  }

  handleRemoveCharPb1() {
    this.Lvl1 = null
    this.Lvl2 = null
  }

  handleRemoveCharPb2() {
    this.Lvl2 = null
  }

  handleChangeBlock (val) {
    if (val && this.dtSavedBlocks.findIndex(x => x.id === val) === -1) {
      let valToAdd = this.blocks.find(x => x.id === val)
      if (valToAdd) {
        this.dtSavedBlocks.push(valToAdd)
      }
    }
    this.Apartment = null
    this.storeGetApartmentsAutocomplete({blockId: this.Block})
      .then(res => {
        this.dtApartments = res
      })
  }

  handleFilter(key: string) {
    return this.storeGetResources({
      entity: [SearchEntities.IndependentContractor],
      query: key
    })
  }

  async handleFetchBlocks (key: string, cb: Function) {
    const param: any = {key}
    return this.storeGetBlocks({param, merge: false}).then(res => {
      return res.map(x => ({value: x.id, firstname: x.name, lastname: '', text: x.name})) || []
    })
  }

  async handleGetApartments(key: string, cb) {
    let payload: any = {
      key,
      blockId: this.Block
    }
    this.storeGetApartmentsAutocomplete(payload)
      .then(res => {
        cb((res || []).map(x => ({
          value: x.id,
          text: x.apartment_number + (x.location_number ? (' / ' + x.location_number) : ''),
          ...x
        })))
      })
      .catch(error => console.log(error))
  }
}

export default BlockEquipmentModalVertical



// WEBPACK FOOTER //
// ./src/containers/block/components/block-equipment-modal-vertical/index.ts